var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo01(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 121,
    viewBox: "0 0 120 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_438_2232)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.479 23.4971C110.34 27.1974 112.755 31.2677 114.65 35.5231L60.0367 76.1524L37.2256 61.7212V44.3298L60.0367 58.761L107.479 23.4971Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.105 59.3898C106.105 59.7598 106.18 60.1299 106.18 60.4999C106.18 86.217 85.5232 107.05 60.0372 107.05C34.5511 107.05 13.8576 86.217 13.8576 60.4999C13.8576 34.7828 34.5139 13.95 60 13.95C69.6594 13.95 78.6502 16.9473 86.0805 22.0907L97.6347 13.395C87.3437 5.03231 74.2663 -0.0371094 60 -0.0371094C26.8607 -0.00010632 0 27.0861 0 60.4999C0 93.9137 26.8607 121 60 121C93.1393 121 120 93.9137 120 60.4999C120 56.7996 119.628 53.2103 118.997 49.695L106.105 59.3898Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_438_2232"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 121,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo01);
export default __webpack_public_path__ + "static/media/logo01.49474d42091b9ba5430eaebbcfabf080.svg";
export { ForwardRef as ReactComponent };